const TET_RED = '#d32f2f';
const TET_GOLD = '#fbc02d';
const TET_GRADIENT = `linear-gradient(90deg, ${TET_RED}, ${TET_GOLD})`;

const isTet = (theme) => theme.colorScheme === 'tet';

export const mantineComponents = {
    Button: {
        styles: (theme, params) => {
            if (!isTet(theme)) return {};
            const isFilledOrDefault = !params?.variant || params?.variant === 'filled';
            if (!isFilledOrDefault) return {};
            return {
                root: {
                    background: TET_GRADIENT,
                    border: 'none',
                    '&:not([disabled]):hover': {
                        background: TET_GRADIENT,
                        filter: 'brightness(0.92)',
                    },
                },
            };
        },
    },

    Checkbox: {
        styles: (theme) => {
            if (!isTet(theme)) return {};
            return {
                input: {
                    '&:checked': {
                        backgroundColor: `${TET_RED} !important`,
                        borderColor: `${TET_RED} !important`,
                    },
                },
            };
        },
    },

    Radio: {
        styles: (theme) => {
            if (!isTet(theme)) return {};
            return {
                radio: {
                    '&:checked': {
                        backgroundColor: `${TET_RED} !important`,
                        borderColor: `${TET_RED} !important`,
                    },
                },
            };
        },
    },

    Tabs: {
        styles: (theme) => {
            if (!isTet(theme)) return {};
            return {
                tab: {
                    '&[data-active]': {
                        borderColor: `${TET_RED} !important`,
                        color: `${TET_RED} !important`,
                    },
                    '&[data-active]:hover': {
                        borderColor: `${TET_RED} !important`,
                        color: `${TET_RED} !important`,
                    },
                },
            };
        },
    },
    Switch: {
        styles: (theme) => {
            if (!isTet(theme)) return {};
            return {
                input: {
                    '&:checked + *': {
                        backgroundColor: `${TET_RED} !important`,
                        borderColor: `${TET_RED} !important`,
                    },
                },
                track: {
                    'input:checked ~ &': {
                        backgroundColor: `${TET_RED} !important`,
                        borderColor: `${TET_RED} !important`,
                    },
                },
            };
        },
    },
    Select: {
        styles: (theme) => {
            if (!isTet(theme)) return {};
            return {
                input: {
                    '&:focus': {
                        borderColor: `${TET_RED} !important`,
                    },
                },
                item: {
                    '&[data-selected]': {
                        backgroundColor: `${TET_RED} !important`,
                        color: 'white !important',
                    },
                },
            };
        },
    },
};
